import react, { useState, useEffect, Fragment } from "react";
import {
  Container, Grid, Typography,
  TableBody, TableCell, TableHead, TableRow, Table,
  Button, Tab, TabPanel, Fab, Accordion, AccordionSummary,
  AccordionDetails,
  FormGroup, Box, Toolbar, Tabs, Divider, Tooltip, FormControlLabel, Switch
} from "@mui/material";
import MapBase from "../components/MapBase";
import Api from "../services/Api";
import CustomContainer from "../components/CustomContainer";
import { SingleSolutionMap } from "../components/SingleSolutionMap";
import { CallComparisonTable, CallComparisonGrid } from "../components/CallComparisonTable";
import { DayOfWeekArray, DayOfWeekMap } from "../utils/constants";
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventIcon from '@mui/icons-material/Event';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import useDocumentTitle from "../hooks/useDocumentTitle";


export const SolutionViewHOC = ({location, ...props}) => {
  const {solutionId} = location.state ? location.state : {};
  const [fullSolution, setFullSolution] = useState(null);
  const [stationList, setStationList] = useState([]);
  const [documentTitle, setDocumentTitle] = useDocumentTitle("")

  useEffect(() => {
    getStationData();
  }, []);

  useEffect(() => {
    setDocumentTitle(fullSolution?.name ?? "");
  }, [fullSolution]);

  useEffect(() => {
    const GetSolution = async (id) => {
      let data = null;
      if (id != null){
        data = await Api.getSingleSolution(id);
      }
      setFullSolution(data);
    }
    GetSolution(solutionId);
  }, [solutionId])

  const getStationData = async () => {
    let stations = await Api.getAllStations();
    if (stations){
      setStationList(stations);
    }
  }

  return (
    <>
    {fullSolution &&
      <SolutionView solution={fullSolution} stationList={stationList}/>
    }
    </>
  )
}

export const SolutionView = (props) => {
  const {solution, stationList} = props;
  const [mapOpen, setMapOpen] = useState(false);
  const [callComparisonData, setCallComparisonData] = useState({});
  const views = ["Weekly", "Daily"];
  const [currentView, setCurrentView] = useState("Weekly");
  const [zeroPeakComparison, setZeroPeakComparison] = useState(true);

  //experiment1
  const [tabValue, setTabValue] = useState(0);
  const [tabTableAssignments, setTabTableAssignments] = useState([]);

  //experiment2
  const [assignmentTableObject, setAssigmentTableObject] = useState(null);

  useEffect(() => {
    getData(solution.id);
  }, [solution, zeroPeakComparison]);

  useEffect(() => {
    let result = processAssignmentsForTable(solution.pauAssignments);
    setAssigmentTableObject(result);
  }, [solution]);

  //for experimental table 1
  useEffect(() => {
    let selectedDayAssigns = [];
    solution.pauAssignments.forEach(x => {
      if (x.dayOfWeek === tabValue){
        selectedDayAssigns.push(x);
      }
    });
    setTabTableAssignments(selectedDayAssigns); 
  }, [tabValue, solution])

  //for experimental table two
  const processAssignmentsForTable = (assignmentList) => {
    let stationSet = new Set();
    assignmentList.forEach(x => {
      stationSet.add(x.station.name);
    }); //create set of all the stations with assignment
    let stationArray = Array.from(stationSet); //turn it into an array for consistent ordering

    let DoWToRenderArray = {} //our final obj
    DayOfWeekArray.forEach(DoW => { //gonna initialize it
      let a = new Array(stationArray.length).fill(null); //create an array equal to size of station array, fill with nulls
      DoWToRenderArray[DoW] = a; //set to the DoW, these arrays will be filled with assignments to render
    });

    assignmentList.forEach(assign => { //iterate through all assignments and add them to their corresponding DoW render array in the right spot
      let DoWString = DayOfWeekArray[assign.dayOfWeek];
      let RenderArray = DoWToRenderArray[DoWString]; //get the day of week and the corresponding render array
      let stationRenderIndex = stationArray.indexOf(assign.station.name); //get the index of the assignment's station to place correctly in render array
      RenderArray[stationRenderIndex] = assign; //add it to its DoW's render array in the correct spot
    });
    // console.log(DoWToRenderArray);
    const returnObject = {DoWToRenderArray: DoWToRenderArray, StationArray: stationArray};
    return returnObject;

  }

  //done experimenting

  const getData = async (id) => {
    let data = await Api.getCallDifference(id, zeroPeakComparison); //get call difference here
    if (data != null){
      setCallComparisonData(data.stationsToBaseAndResultCalls);
    }
  }

  const getButtonName = (currView) => {
    let x = views.indexOf(currView);
    let y = 1 - x;
    return views[y];
  }

  const swapButton = (currView) => {
    let x = views.indexOf(currView);
    let y = 1 - x;
    setCurrentView(views[y]);
  }


  const getTableName = (currView) => {
    if (currView === views[1]) {
      return DayOfWeekArray[tabValue];
    }
    return "Full";
    
  }

  const getActiveDataForTable = () => {
    if (currentView === views[0]){ //if weekly
      return "All";
    }else if (currentView === views[1]){
      return DayOfWeekArray[tabValue];
    }
  }

  // const toggleZeroComparison = async (e) => {
  //   if (e.target.checked !== zeroPeakComparison){
  //     let getDataAwait = getData(solution.id);
  //     setZeroPeakComparison(e.target.checked);
  //     await getDataAwait();
  //   }
  // }

  return (
    <>
      {mapOpen &&
        <CustomContainer>
          <SingleSolutionMap assignments={(currentView === views[0]) ? solution.pauAssignments : tabTableAssignments} stationList={stationList}/>
          <div style={{padding: '1em'}}>
            <Button variant="contained" onClick={() => setMapOpen(false)}>
              Close
            </Button>
          </div>
        </CustomContainer>
      }
      {!mapOpen && solution &&
      <Container>
        <Tooltip title={`Swap to ${getButtonName(currentView)} view`}>
          <Fab color="primary" sx={{position: "fixed", right: "10%", bottom: "5%"}} onClick={() => swapButton(currentView)}>
           {currentView === views[0] ? <EventIcon/> : <DateRangeIcon/>}
          </Fab>
        </Tooltip>
        <Grid container justifyContent="center" padding={"2em"} spacing={1}>
          <Grid item xs={12} textAlign="center">
            <Typography variant="h4">
              {solution.name} PAU Schedule
            </Typography>
          </Grid>
          <Grid item xs={12}>
          { currentView === views[1] &&
            <Toolbar sx={{justifyContent: "center"}}>
              
                <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                  {DayOfWeekArray.map((x, i) => 
                    <Tab value={i} label={x}/>
                  )}  
                </Tabs>
            </Toolbar>
          }
          </Grid>
          <Grid item xs={12} sx={{overflowX: "auto"}}>
            {/* <Typography variant="h5">
              {`${getTableName(currentView)} Assignments`}
            </Typography> */}
            {currentView === views[1] &&
              <DailyScheduleTable tabTableAssignments={tabTableAssignments} />
            }
            {currentView === views[0] &&
            <FullWeekScheduleTable assignmentTableObject={assignmentTableObject}/>
            }
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{height: "25em"}}>
            <Container sx={{height: "100%"}}>
              <SingleSolutionMap height={"88%"} assignments={(currentView === views[0]) ? solution.pauAssignments : tabTableAssignments} stationList={stationList}/>
              <Button variant="contained" onClick={() => setMapOpen(true)} sx={{marginTop: ".5em"}}>
                  View Full Size Map
              </Button>
            </Container>
          </Grid>
          <Grid item xs={6}>
              <Toolbar disableGutters>
                <Typography variant="h5">
                  Schedule Metrics
                </Typography>
                {/* <FormGroup sx={{marginLeft: "5em"}}>
                  <FormControlLabel label={<Typography sx={{fontSize: '.9em'}} variant="subtitle1">Compare to Zero Peak Deployment</Typography>}
                    control={<Switch checked={zeroPeakComparison} onChange={(e) => setZeroPeakComparison(e.target.checked)}/>}
                  />
                </FormGroup> */}
              </Toolbar>

              <MetricTable metrics={solution.metrics ? solution.metrics : []} />
          </Grid>
        </Grid>
        <CustomContainer style={{marginTop: ".5em", marginBottom: "1em", justifyContent: "center"}}>
        <Accordion elevation={2}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
            >
              <Typography sx={{fontWeight: "bold"}}>
              {getTableName(currentView)} Schedule Comparison (Calls Per Month)
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
            <>
            <CallComparisonGrid data={callComparisonData[getActiveDataForTable()]}/>
          </>
            </AccordionDetails>
            </Accordion>
        </CustomContainer>

      </Container>
      }
    </>
  )
}

const parseTime = (timespan) => {
  // console.log(timespan);
  // let duration = moment.duration(timespan);
  // console.log(duration);
  // let momUtc = moment.utc(duration);
  // console.log(momUtc);
  // let fString = moment.utc(duration).format("HH:mm");
  // console.log(fString);
  let fString = timespan.slice(0, 5);
  return fString;

}

export const FullWeekScheduleTable = ({assignmentTableObject}) => {
  if (assignmentTableObject == null){
    return "";
  }
  const {DoWToRenderArray, StationArray} = assignmentTableObject;

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell/>
          {StationArray.map(stationName => 
            <TableCell key={stationName}>{stationName}</TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.keys(DoWToRenderArray).map(dayOfWeek => 
          <TableRow key={dayOfWeek}>
            <TableCell sx={{fontWeight: "500"}}>{dayOfWeek}</TableCell>
            {DoWToRenderArray[dayOfWeek].map((assignment, idx) =>
              <TableCell key={idx}>{(assignment == null) ? "" : parseTime(assignment.startTime)}</TableCell>
            )}
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}

const DailyScheduleTable = ({tabTableAssignments}) => {
  return (
    <Box sx={{justifyContent: "center"}}>
      <Box sx={{justifyContent: "center"}}>
        {tabTableAssignments &&
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                {tabTableAssignments.map(assign => {
                  return <TableCell>{assign.station.name}</TableCell>
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{fontWeight: "500"}}>
                  Start Time
                </TableCell>
                {tabTableAssignments.map(assign => {
                  return <TableCell>{parseTime(assign.startTime)}</TableCell>
                })}
              </TableRow>
            </TableBody>
          </Table> 
          }
      </Box>
    </Box>
  )
}

const MetricTable = ({metrics, ...props}) => {

  return (
    <Table>
      <TableHead>
        {metrics && metrics.map(metric => {
          return (
            <TableCell key={metric.id}>
              {metric.label}
            </TableCell>
          )
        })}
      </TableHead>
      <TableBody>
        {metrics && metrics.map(metric => {
            return (
              <TableCell key={metric.id}>
                {metric.value}
              </TableCell>
            )
        })}
      </TableBody>
    </Table>
  )
}

const ObjectiveTable = ({data, ...props}) => {
  console.log(data);
  return (
    <Table>
      <TableHead>
        {data.baseObjectives && Object.keys(data.baseObjectives).map(key =>
        <Fragment key={key}>
          <TableCell>
            Base {key}
          </TableCell>
          <TableCell>
            New {key}
          </TableCell>
        </Fragment> 
        )}
      </TableHead>
      <TableBody>
       {data.baseObjectives && Object.keys(data.baseObjectives).map(key =>
        <Fragment key={key}>
          <TableCell>
            {+(data.baseObjectives[key]).toFixed(2)}
          </TableCell>
          <TableCell>
            {+(data.newObjectives[key]).toFixed(2)}
          </TableCell>
        </Fragment> 
        )}
      </TableBody>
    </Table>
  )
}

export default SolutionViewHOC;